<script lang="ts">
	import HDSchedule from '#lib/hockeydata/components/HDSchedule.svelte';

	const { data } = $props();
</script>

<h2 class="mb-3">Spielplan</h2>
<HDSchedule season={data.season} teamId={data.ownTeamId?.toString()} />
